<mat-icon [color]="color"
          [inline]="inline"
          [fontSet]="fontSet"
          [fontIcon]="fontIcon">{{ matIcon }}</mat-icon>